import * as React from "react";
import "./WhoItIsFor.scss";
import { ClassableProps, baseClassAnd, childClassClosure } from "@jcharlesworthuk/your-mum-core/dist/functions";

const baseClass = 'who-it-is-for';
const childClass = childClassClosure(baseClass);

type Props = ClassableProps & {
  items: ItemProps[]
};

type ItemProps = {
  title: string;
  iconPath: string
}

export type WhoItIsForRef = HTMLUListElement;

const WhoItIsFor: React.RefForwardingComponent<WhoItIsForRef, Props> = (props: Props, ref )  => {
  return <ul ref={ref} className={baseClassAnd(baseClass, props)}>
    {props.items.map((item, i) => <li key={i}>
      <img className={childClass('image')} src={item.iconPath} alt={item.title} />
      <h4 className={childClass('title')}>{item.title}</h4>
    </li>)}
  </ul>
}

export default React.forwardRef<WhoItIsForRef, Props>(WhoItIsFor);